const RICOS_VERSION = "10.146.1";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
